// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.infobox[data-v-0992700a] {\n\t  background: var(--blue-light-bg);\n\t  padding: 15px;\n\t  border: 1px solid var(--blue-darker-border);\n\t  color: #305c89;\n\t  font-size: 13px;\n\t  border-radius: 3px;\n}\n.infobox .w-link[data-v-0992700a]{ text-decoration: underline;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
